import AOS from 'aos';
// import 'aos/dist/aos.css'; // You can also use <link> for styles

$(document).ready(function() {
    if($('.card-grid .card-logo').length > 0) {
        // Get all card logo elements
        var $cardLogos = $('.card-grid .card-logo');
        
        // Set src attributes first
        $cardLogos.each(function() {
            $(this).attr('src', $(this).data('src'));
        });

        // After images load, get max height and apply to all
        $cardLogos.find('img').on('load', function() {
            var maxHeight = 0;
            
            // Find the maximum height
            $cardLogos.each(function() {
                var height = $(this).height();
                maxHeight = Math.max(maxHeight, height);
            });

            // Set all logos to max height
            $cardLogos.height(maxHeight);
        });
    }
});

AOS.init({
    once: true,
    delay: 50,
    offset: 0,
    duration: 600,
    easing: 'ease-in-out',
    mirror: false,
    // anchorPlacement: 'top-bottom',
});


// Video Modal Handler
document.addEventListener('DOMContentLoaded', function() {
    const videoModal = document.getElementById('videoModal');
    if (videoModal) {
        const modalIframe = videoModal.querySelector('iframe');
        
        videoModal.addEventListener('show.bs.modal', function(event) {
            const button = event.relatedTarget;
            const videoUrl = button.getAttribute('data-video-url');
            modalIframe.setAttribute('src', videoUrl+'?rel=0&autoplay=1');
            modalIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        });

        videoModal.addEventListener('hidden.bs.modal', function() {
            modalIframe.setAttribute('src', '');
            // modalIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }
});

// Gated Content Modal
document.addEventListener('DOMContentLoaded', function() {
    const gatedContentModal = document.getElementById('gatedContentModal');

    if (gatedContentModal) {
        document.body.classList.add('gated-page');
        const gatedForm = gatedContentModal.getAttribute('data-gated-form');
        
        // Listen for form submission
        jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
            if (formId == gatedForm) {
                // Hide modal and show content
                document.getElementById('gatedContentModal').style.display = 'none';
                document.body.classList.remove('gated-page');
            }
        });
    }
});

// Disable auto-play video and AOS when user prefers reduced motion
const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (isReduced) {
    const video = document.querySelector('video');
    if (video) {
        video.pause();
    }
    AOS.init({
        disable: true,
    });
}
